import Invoice from "../pages/invoice/pages/Invoice";
import { USER_ROLES } from "../utils/userRole";

const permissions = [USER_ROLES.ADMIN, USER_ROLES.USER]

const InvoiceRoutes = [
  {
    path: '/invoice',
    component: Invoice,
    exact: true,
    permissions,
  },
  
];

export default InvoiceRoutes
